
import Vue from "vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";

export default Vue.extend({
  name: "trans-program-person-with-dis-content",
  mixins: [UIFeatureMixin],
});
